import React from 'react';

import Pagination from '@amzn/awsui-components-console/pagination';

export interface PaginationControlProps {
  currentPageIndex: number;
  pagesCount: number;
  openEnd?: boolean;
  disabled?: boolean;
  onPageChange: (pageIndex: number) => void;
}

const PaginationControl: React.FC<PaginationControlProps> = ({
  currentPageIndex,
  pagesCount,
  openEnd,
  disabled,
  onPageChange,
}) => (
  <Pagination
    currentPageIndex={currentPageIndex}
    pagesCount={pagesCount}
    openEnd={openEnd}
    disabled={disabled}
    onChange={({ detail }) => onPageChange(detail.currentPageIndex)}
    ariaLabels={{
      nextPageLabel: 'Next page',
      previousPageLabel: 'Previous page',
      pageLabel: (pageNumber) => `Page ${pageNumber}`,
    }}
  />
);

export default PaginationControl;
